import React from 'react'
import { BookingShiftDetailProvider } from './context/BookingShiftDetailProvider'
import { BookingShiftDetailMain } from './components/BookingShiftDetailMain'

export const BookingShiftDetail = ({
  shiftId,
  shiftIdx,
}: {
  shiftId: number
  shiftIdx: number
}) => {
  return (
    <BookingShiftDetailProvider shiftId={shiftId} shiftIdx={shiftIdx}>
      <BookingShiftDetailMain />
    </BookingShiftDetailProvider>
  )
}
